<template>
  <form v-if="contract.signs" class="w-full m-center" @submit="submit">
    <div class="content flex flex-wrap">
      <h1 class="mb-6">Carta prepagata</h1>

      <div class="w-full mb-3">
        <div
          class="outline-link"
          :class="{ read: contract.read }"
          @click="openContract(contract.documentId)"
        >
          <div class="outline-link__text">{{ contract.description }}</div>
          <div class="outline-link__status">
            {{ contract.read ? "Letto" : "Leggi per proseguire" }}
          </div>
        </div>
      </div>

      <div v-if="contract.read">
        <div
          class="w-full mt-5 mb-3 font-system"
          v-for="sign in contract.signs"
          :key="sign.id"
        >
          <div class="tnb-checkbox">
            <div class="inline-flex">
              <input type="checkbox" :id="sign.id" v-model="sign.checked" />
              <label v-html="sign.description" :for="sign.id"></label>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="page-footer">
      <button
        class="btn"
        type="submit"
        :disabled="
          !contract.read ||
            contract.signs.filter(s => s.checked).length < contract.signs.length
        "
      >
        Prosegui
      </button>
    </div>
  </form>
</template>

<script>
import { sameAs } from "vuelidate/lib/validators";
import DocumentsService from "@/services/DocumentsService";
//import validations from "@/utils/validations";
//import ValidationText from "@/components/ValidationText";

export default {
  name: "InfocertSign",
  components: {
    // ValidationText
  },
  data() {
    return {
      infocertData: this.$store.state.user.infocert,
      contract: {}
    };
  },
  validations: {
    privacyTerm: {
      checked: {
        sameAs: sameAs(() => true)
      }
    },
    generalConditionRead: {
      sameAs: sameAs(() => true)
    }
  },
  mounted() {
    const minorId = this.$store.state.user.id;
    DocumentsService.getMyContracts(minorId).then(response => {
      this.contract = response.contracts
        .filter(t => t.documentId === "ID3" || t.documentId === "ID503")
        .map(c => {
          c.read = false;
          c.signs.map(s => {
            s.checked = false;
            return s;
          });
          return c;
        })[0];
    });
  },
  methods: {
    openContract(id) {
      const minorId = this.$store.state.user.id;
      this.contract.read = true;
      DocumentsService.openContract(id, minorId);
    },
    submit(event) {
      event.preventDefault();
      if (this.loading) return;
      this.loading = true;
      this.stepCompleted();
    },
    stepCompleted() {
      this.$root.$emit("submitStep");
    }
  }
};
</script>
<style lang="less" scoped>
.tnb-radio {
  align-items: center;
  label {
    margin: 0;
  }
}
</style>
